import useUploadChecksDialogViewModel from './UploadChecksDialogViewModel'
import cn from 'clsx'

import CustomModal from '@/components/shared/CustomModal/CustomModal'
import { UploadFile } from '@components/shared/UploadFile'

import './UploadChecksDialog.css'

const UploadChecksDialog = ({
    className,
    onClose,
}) => {
    
    const {
        BATCH_COUNT,
        refUploads,
        error,
        setError,
        open,
        setOpen,
        files,
        onDrop,
        isUploading,
        fileUploads,
        batchedFiles,
        completedCount,
        
        /* nameOverrides,
        updateNameOverride, */
        
        getProgressWidth,
        totalProgressWidth,
        closeDialog,
        handleSubmit,
        state,
    } = useUploadChecksDialogViewModel(onClose)
    
    return (
        
        <CustomModal
            ref={refUploads}
            className={cn('UploadChecksDialog', className)}
            style={{ maxWidth: '30%' }}
            open={open}
            modalHandler={() => setOpen(false)}
            center>
            
            <div className="modal-body">
                
                <div className="mt-5">
                    <h3 className="text-2xl">Upload Checks</h3>
                </div>
                
                <div className="modal-body-inner overflow-h-auto">
                    
                    {state === 'error' && (
                        <div className="justify-center mt-4 text-center">
                            <h4 className="mb-2 text-lg">
                                Upload Failed
                            </h4>
                            <p>{error}</p>
                            <button
                                className="w-auto mt-4 btn btn-primary"
                                onClick={() => setError(null)}>
                                Try Again
                            </button>
                        </div>
                    )}
                    
                    {state === 'ready' && (
                        <div className="flex items-center content-center mt-4">
                            <UploadFile
                                className="w-full"
                                dropzoneClassName="flex flex-col justify-center h-20"
                                name="file"
                                accept={{ 'application/pdf': [] }}
                                onDrop={onDrop}
                                fieldName="check"
                                showUploadIcon={false} />
                        </div>
                        
                    )}
                    
                    {state === 'edit' && (<>
                        
                        {/*
                        Org is required, but intentionally start with the value
                        unselected, so they don't accidentally upload to the wrong org
                        */}
                        
                        <table className="w-full mt-4 table-auto">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>File Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {files.map(it => (
                                    <tr key={it.name}>
                                        <td>
                                            {it.name}
                                            {/* @todo let users rename checks when uploading */}
                                            {/* <input
                                                className=""
                                                type="text"
                                                value={nameOverrides[i] ?? it.name}
                                                onChange={e => updateNameOverride(e, i)} /> */}
                                        </td>
                                        <td>
                                            {it.name}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>)}
                    
                    {state === 'uploading' && (
                        <div className="mt-4">
                            {files.length > BATCH_COUNT && (
                                <div className="progress overall-progress" style={{ height: '8px', width: '100%' }}>
                                    <div
                                        className="progress-bar bg-info"
                                        style={{ width: totalProgressWidth }}
                                        role="progressbar"
                                        aria-valuemin={0}
                                        aria-valuemax={files.length}
                                        aria-valuenow={completedCount} />
                                </div>
                            )}
                            <table className="w-full mt-4 table-auto">
                                <tbody>
                                    {batchedFiles.map(it => (
                                        <tr key={it.name}>
                                            <td>{it.name}</td>
                                            <td>
                                                <div className="progress" style={{ height: '8px', width: '100%' }}>
                                                    <div
                                                        className="progress-bar bg-info"
                                                        style={{
                                                            width: getProgressWidth(fileUploads[it.name]),
                                                        }}
                                                        role="progressbar"
                                                        aria-valuemin={0}
                                                        aria-valuemax={fileUploads[it.name]?.max ?? 0}
                                                        aria-valuenow={fileUploads[it.name]?.value ?? 0} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                
                </div>
            
            </div>
            
            <div className="flex justify-end modal-footer">
                <button
                    className="mr-3 btn btn-primary btn-outline"
                    onClick={closeDialog}>
                    Cancel
                </button>
                <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={error || !files.length || isUploading}
                    onClick={handleSubmit}>
                    Upload
                </button>
            </div>
        
        </CustomModal>
        
    )
    
}

export default UploadChecksDialog
